import classNames from "classnames";

interface EqualizerProps {
  isPlaying: boolean;
}

const Equalizer = ({ isPlaying }: EqualizerProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="ml-2"
    >
      <path
        d="M6.50947 0C6.2076 0 5.96288 0.214904 5.96288 0.48V15.52C5.96288 15.7851 6.2076 16 6.50947 16C6.81135 16 7.05606 15.7851 7.05606 15.52V0.48C7.05606 0.214903 6.81135 0 6.50947 0Z"
        fill="#87B7FF"
        className={classNames({
          "animate-equalizer [animation-delay:-0.2s]": isPlaying,
        })}
      />
      <path
        d="M11.9258 3.10656C11.9258 2.84147 12.1705 2.62656 12.4724 2.62656C12.7742 2.62656 13.0189 2.84147 13.0189 3.10656V12.8894C13.0189 13.1545 12.7742 13.3694 12.4724 13.3694C12.1705 13.3694 11.9258 13.1545 11.9258 12.8894V3.10656Z"
        fill="#87B7FF"
        className={classNames({
          "animate-equalizer [animation-delay:-0.4s]": isPlaying,
        })}
      />
      <path
        d="M0.546591 6.51562C0.244717 6.51562 0 6.73053 0 6.99563V9.00705C0 9.27215 0.244717 9.48705 0.546591 9.48705C0.848465 9.48705 1.09318 9.27215 1.09318 9.00705V6.99563C1.09318 6.73053 0.848465 6.51562 0.546591 6.51562Z"
        fill="#87B7FF"
        className={classNames({
          "animate-equalizer [animation-delay:-0.1s]": isPlaying,
        })}
      />
      <path
        d="M15.4534 5.71563C15.1515 5.71563 14.9068 5.93053 14.9068 6.19563V9.80705C14.9068 10.0722 15.1515 10.2871 15.4534 10.2871C15.7553 10.2871 16 10.0721 16 9.80705V6.19563C16 5.93053 15.7553 5.71563 15.4534 5.71563Z"
        fill="#87B7FF"
        className={classNames({
          "animate-equalizer [animation-delay:-0.3s]": isPlaying,
        })}
      />
      <path
        d="M3.52787 3.42656C3.22599 3.42656 2.98127 3.64147 2.98127 3.90656V12.0894C2.98127 12.3545 3.22599 12.5694 3.52787 12.5694C3.82974 12.5694 4.07446 12.3545 4.07446 12.0894V3.90656C4.07446 3.64147 3.82974 3.42656 3.52787 3.42656Z"
        fill="#87B7FF"
        className={classNames({
          "animate-equalizer [animation-delay:-0.5s]": isPlaying,
        })}
      />
      <path
        d="M8.94416 5.05344C8.94416 4.78834 9.18887 4.57344 9.49075 4.57344C9.79262 4.57344 10.0373 4.78834 10.0373 5.05344V10.9506C10.0373 11.2157 9.79262 11.4306 9.49075 11.4306C9.18887 11.4306 8.94416 11.2157 8.94416 10.9506V5.05344Z"
        fill="#87B7FF"
        className={classNames({
          "animate-equalizer [animation-delay:-0.2s]": isPlaying,
        })}
      />
    </svg>
  );
};

Equalizer.displayName = "Equalizer";

export default Equalizer;
